import { type ApplicationDto, listApplications } from '@avila-roffe/api-clients-admin-bff';
import { useQuery } from '@tanstack/react-query';
import { toList, unwrap } from '../lib/api';

export const applicationKeys = {
  all: ['applications'] as const,
  lists: () => [...applicationKeys.all, 'list'] as const,
};

export function useApplications() {
  return useQuery({
    queryKey: applicationKeys.lists(),
    queryFn: async () => {
      const res = await listApplications({ limit: 500, offset: 0 });
      return toList<ApplicationDto>(unwrap<{ items?: ApplicationDto[] } | ApplicationDto[]>(res));
    },
  });
}
